import axios from "axios";
import { Navigate } from "react-router-dom";

export const load_transactions_list = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/payments_api/transactions/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}
export const load_transaction_by_id = async (id) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/payments_api/transaction/${id}`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}

export const edit_transaction_from_id = async (id, data, file) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': `multipart/form-data`,
        'Authorization': `JWT ${localStorage.getItem('access')}`,
      }
    };
    const fixedData = { ...data }
    function getFormData(object) {
      const formData = new FormData();
      Object.keys(object).forEach(key => {
        if (object[key] && typeof object[key] == 'object' || Array.isArray(object[key])) {
          formData.append(key, JSON.stringify(object[key]))
          console.log(object[key])
        } else {
          formData.append(key, object[key])
        }
      });
      return formData;
    }
    const fData = getFormData(fixedData);
    fData.delete('file');
    if (fixedData.file_name == "") {
      fData.delete('file_name')
    }
    fData.append('file', file.file);

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/payments_api/transaction/${id}`, fData, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const upload_transaction = async (data, file) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': `multipart/form-data`,
        'Authorization': `JWT ${localStorage.getItem('access')}`,
      }
    };
    const fixedData = { ...data }

    function getFormData(object) {
      const formData = new FormData();
      Object.keys(object).forEach(key => {
        if (object[key] && typeof object[key] == 'object' || Array.isArray(object[key])) {
          formData.append(key, JSON.stringify(object[key]))
          console.log(object[key])
        } else {
          formData.append(key, object[key])
        }
      });
      return formData;
    }

    const fData = getFormData(fixedData);
    fData.append('file', file.file);

    // for (const [key, value] of fData.entries()) {
    //   console.log(`${key}: ${value}`);
    // }
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/payments_api/transactions/`, fData, config);

      return response.data;
    } catch (err) {
      return err;
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const delete_transaction_from_id = async (id) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };

    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/payments_api/transaction/${id}`, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const load_annual_summary = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/payments_api/transactions/annual_summary/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}